import { TFunction } from 'i18next';

import { AccommodationCategory } from 'proto/Accommodation/AccommodationCategory';

const getAccommodationTypeLabel = (
    accommodationType: AccommodationCategory,
    t: TFunction
) => {
    switch (accommodationType) {
        case AccommodationCategory.Aparthotel:
            return t('TRANS-aparthotel');
        case AccommodationCategory.BedAndBreakfast:
            return t('TRANS-bedandbreakfast');
        case AccommodationCategory.BoardingHouse:
            return t('TRANS-boardinghouse');
        case AccommodationCategory.Camping:
            return t('TRANS-camping');
        case AccommodationCategory.HolidayHome:
            return t('TRANS-holidayhome');
        case AccommodationCategory.HolidayHouse:
            return t('TRANS-holidayhouse');
        case AccommodationCategory.Hostel:
            return t('TRANS-hostel');
        case AccommodationCategory.Hotel:
            return t('TRANS-hotel');
        case AccommodationCategory.Motel:
            return t('TRANS-motel');
        case AccommodationCategory.Special:
            return t('TRANS-special');
        default:
            return '';
    }
};

export default getAccommodationTypeLabel;
